module.exports = __webpack_public_path__ + "static/media/gts16.720e18cd.png";